import containerFuild from '../../description/html-snippets/container-fuild.js';
import css from '../css-snippets/section-leonieandco-review-grid.js';

const content_1 = `
  <p><span style="color:hsl(336,52%,31%);"><strong>✨ Visible results in just a few weeks&nbsp;</strong></span></p>
  <p><span style="font-size:13px;"><i>« I was sceptical before ordering, but after 2 months of wearing the 3D leggings from Leonie and Co for just 2 hours a day, my skin is much smoother and I've finally regained my confidence! »</i></span></p>
`;
const content_2 = `
  <p><span style="color:hsl(336,52%,31%);"><strong>So happy with the results&nbsp;</strong></span></p>
  <p><span style="font-size:13px;"><i>« I had been insecure about my cellulite for years, especially in summer. Wearing these 3D leggings regularly, I've seen my skin become smoother and more refined. Now I finally feel comfortable wearing dresses again without hiding. »</i></span></p>
`;
const content_3 = `
  <p><span style="color:hsl(336,52%,31%);"><strong>The only legging that truly worked&nbsp;</strong></span></p>
  <p><span style="font-size:13px;"><i>« I tried so many creams with no real results. These leggings, however, really surprised me. By wearing them every day, my cellulite has reduced and my thighs feel much firmer. I never thought I'd see such a change. »</i></span></p>
`;
const content_4 = `
  <p><span style="color:hsl(336,52%,31%);"><strong>My ally after pregnancy&nbsp;</strong></span></p>
  <p><span style="font-size:13px;"><i>« After giving birth, I was looking for a simple solution to regain confidence. With these leggings, my legs look visibly firmer and I even lost a bit around my waist. I wear them almost every day – they've become my go-to for feeling good. »</i></span></p>
`;
const content_5 = `
  <p><span style="color:hsl(336,52%,31%);"><strong>Lighter, firmer legs&nbsp;</strong></span></p>
  <p><span style="font-size:13px;"><i>« I often suffered from heavy legs at the end of the day. Since wearing these leggings, I feel a real difference: my circulation has improved, my skin is smoother and my thighs much firmer. It's real everyday comfort. »</i></span></p>
`;

const starIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" />
  </svg>
`;

const defaultItems = [
  {
    header: 'Emma (38 yrs)',
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0a806b99c8bf0706e3fda.webp?w=1000',
    rating: 5,
    value: content_1,
  },
  {
    header: 'Claire (43 yrs)',
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0a8e0254326035fda791f.webp?w=1000',
    rating: 5,
    value: content_2,
  },
  {
    header: 'Hannah (31 yrs)',
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0a8f200c53617b0514474.webp?w=1000',
    rating: 5,
    value: content_3,
  },
  {
    header: 'Charlotte (36 yrs)',
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0a903adba422f6986ccd8.webp?w=1000',
    rating: 5,
    value: content_4,
  },
  {
    header: 'Sophie (40 yrs)',
    image: 'https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0a910370d7175af583b7f.webp?w=1000',
    rating: 5,
    value: content_5,
  },
];

const renderTab = (item, index) => `
  <button
    type="button"
    class="leonieandco-review-grid__tab${index === 0 ? ' active' : ''}"
    data-attribute="leonieandco-review-grid__tab"
    data-index="${index}"
    data-active="${index === 0 ? 'true' : 'false'}"
  >${item.header}</button>
`;

const renderSlide = item => `
  <div class="swiper-slide" data-attribute="leonieandco-review-grid__item">
    <article class="leonieandco-review-grid__review">
      <img
        loading="lazy"
        class="leonieandco-review-grid__image"
        data-attribute="leonieandco-review-grid__image"
        src="${item.image}"
        alt="Leonie and Co customer before and after result"
      />
      <div class="leonieandco-review-grid__review-body">
        <div
          class="leonieandco-review-grid__stars"
          data-attribute="leonieandco-review-grid__stars"
          data-value="${item.rating}"
        >${Array(5)
          .fill(starIcon)
          .join('')}</div>
        <div
          class="leonieandco-review-grid__value"
          data-attribute="leonieandco-review-grid__value"
        >${item.value}</div>
      </div>
    </article>
  </div>
`;

const contentHtml = `
  <div
    class="leonieandco-review-grid"
    data-attribute="leonieandco-review-grid"
    data-star-color="#00B979"
    data-tab-header-color="#772647"
    data-content-background="#fcf8f5"
    style="--leonieandco-star-color: #00B979; --leonieandco-tab-header-color: #772647; --leonieandco-content-background: #fcf8f5;"
  >
    <div class="leonieandco-review-grid__inner">
      <div
        class="leonieandco-review-grid__header"
        data-attribute="leonieandco-review-grid__header"
      >
       <h2 style="text-align:center;"><span style="color:hsl(336,52%,31%);"><i><strong>Before &amp; After</strong></i></span><strong> &nbsp;from our customers ⭐</strong></h2>
      </div>
      <div
        class="leonieandco-review-grid__tabs"
        data-attribute="leonieandco-review-grid__tabs"
        role="tablist"
      >${defaultItems.map(renderTab).join('')}</div>
      <div class="swiper leonieandco-review-grid__swiper">
        <div
          class="swiper-wrapper"
          data-attribute="leonieandco-review-grid__list"
        >${defaultItems.map(renderSlide).join('')}</div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css);
